import { Box, SingleSelect, Text } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

const ERROR_MESSAGE = "The error would be gone once select Santa Cruz";

export default () => {
	const [isInvalid, setIsInvalid] = useState<boolean>(true);
	const [error, setError] = useState<string>(ERROR_MESSAGE);

	return (
		<Box height={60}>
			<CssColumnGrid columns={2}>
				<Text semiBold text="Error Text" />
				<Text semiBold text="Helper Text" />
				<SingleSelect
					helperText={error}
					invalid={isInvalid}
					onChange={(e, item) => {
						if (item.id === "7") {
							setIsInvalid(false);
							setError("");
						} else {
							setIsInvalid(true);
							setError(ERROR_MESSAGE);
						}
					}}
					options={items}
					value={items[0]}
				/>
				<SingleSelect
					helperText="This is helper Text"
					options={items}
					value={items[0]}
				/>
			</CssColumnGrid>
		</Box>
	);
};